import React from 'react';

type InfoCardItemProps = {
	title: string;
	description: string | number | null | undefined;
	textStyle: string | undefined | null;
};

export const InfoCardItem = ({
	title,
	description,
	textStyle,
}: InfoCardItemProps) => {
	if (textStyle) {
		return (
			<div className="col">
				<strong>{title}</strong>
				<br />
				<label>{description}</label>
			</div>
		);
	} else {
		return (
			<div className="col">
				<label>{title}</label>
				<br />
				<strong>{description}</strong>
			</div>
		);
	}
};
